import AdminLayout from "@/layout/Admin";

const adminRouter = {
  path: "/admin",
  name: "Admin",
  redirect: "/admin/org-statuses",
  component: AdminLayout,
  children: [
    {
      path: "org-statuses",
      name: "AdminOrgStatuses",
      component: () => import("@/views/Admin/AdminOrgStatuses.vue"),
      meta: {
        admin: true,
      },
    },
    {
      path: "org-statuses/catalog",
      name: "AdminOrgStatuses-Catalog",
      component: () => import("@/views/Admin/AdminOrgStatuses/Catalog.vue"),
      meta: {
        admin: true,
      },
    },
    {
      path: "org-statuses/catalog/update",
      name: "AdminOrgStatuses-Catalog-Update",
      component: () => import("@/views/Admin/AdminOrgStatuses/Catalog/Update.vue"),
      meta: {
        admin: true,
      },
    },
    {
      path: "registrate-ec",
      name: "RegistrateEC",
      component: () => import("@/views/Admin/RegistrateEC.vue"),
      meta: {
        admin: true,
      },
    },
    {
      path: "registrate-ec/create",
      name: "RegistrateEC-Create",
      component: () => import("@/views/Admin/RegistrateEC/Create.vue"),
      meta: {
        admin: true,
      },
    },
    {
      path: "requests",
      name: "Requests",
      component: () => import("@/views/Admin/Requests.vue"),
      meta: {
        admin: true,
      },
    },
    {
      path: "requests/notifications_telegram",
      name: "RegistrateEC-NotificationsTelegram",
      component: () => import("@/views/Admin/Requests/NotificationsTelegram.vue"),
      meta: {
        admin: true,
      },
    },
  ],
};

export default adminRouter;
